let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("zuP1l")).then(() => parcelRequire('cxLwp'));